export enum EGatewayPaymentType {
  CARD = 'CARD',
  BOLETO = 'BOLETO',
  PIX = 'PIX',
}
